import styled from "styled-components";
import React, { useState, useEffect } from "react";
import { ValidateAccess } from "global/authorization";
import { UseUserContext } from "contexts";

const B = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background-color: var(--color-coral);
  color: #fff;
  border: 1px solid transparent;
  text-transform: none;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 1.3rem;
  line-height: 1;
  letter-spacing: 0.01em;
  text-align: center;
  cursor: pointer;
  min-width: 14rem;
  height: 3.6rem;
  padding: 0 1.6rem;
  box-shadow: 0 6px 18px rgba(232, 72, 79, 0.22);
  transition: background-color .2s ease, transform .2s ease, box-shadow .2s ease, color .2s ease, border-color .2s ease;

  &.secondary {
    background-color: var(--color-background-white);
    color: var(--color-plum);
    border: 1.5px solid rgba(61, 30, 92, 0.14);
    box-shadow: var(--shadow-soft);
  }
  &.secondary:hover {
    background-color: var(--color-background-white);
    color: var(--color-coral);
    border-color: var(--color-coral);
    transform: translateY(-1px);
  }

  &.tertiary {
    background-color: transparent;
    color: var(--color-plum);
    border: 1.5px solid rgba(61, 30, 92, 0.10);
    box-shadow: none;
  }
  &.tertiary:hover {
    color: var(--color-coral);
    border-color: var(--color-coral);
  }

  &:hover {
    background-color: var(--color-coral-deep);
    transform: translateY(-1px);
    box-shadow: 0 10px 26px rgba(232, 72, 79, 0.32);
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
  }

  .button-icon {
    margin-right: .4rem;
    font-size: 1.2rem;
    display: inline-flex;
    > * { color: inherit; }
  }
`;
const A = styled.a``;

export default function Button({label, url, onClick, type, buttonType, disabled, roles, children}) {
  const [hide, setHide] = useState(true);
  const { permissions } = UseUserContext();

  useEffect(async () => {
    const access = await ValidateAccess(roles, permissions);
    setHide(!access);
  }, [permissions]);

  if (url) {
    return (
      <a href={url}>
        <B onClick={onClick} roles={roles}>{label}</B>
      </a>
    );
  } else {
    return (
      <>
      { !hide &&
        <B className={`${type} ${disabled ? "disabled" : ""}`} onClick={onClick} roles={roles} type={buttonType || "button"} disabled={disabled}>
          <div className="button-icon">{children}</div>
          {label}
        </B>}
      </>
    );
  }
}

Button.defaultProps = {
  label: "button",
  onClick: () => console.log("click"),
  type: "primary",
};